if (!customElements.get('sample-purchase')) {
  customElements.define('sample-purchase', class extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-sample-modal]');
      this.preview = this.querySelector('[data-sample-preview]');
      this.lastFocus = null;
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('change', (event) => this.onChange(event));
      this.modal.addEventListener('click', (event) => this.onClick(event));
      this.modal.addEventListener('change', (event) => this.onChange(event));
      this.preview.addEventListener('click', (event) => this.onClick(event));
      document.body.append(this.modal, this.preview);
      this.boundKeydown = (event) => this.onKeydown(event);
      document.addEventListener('keydown', this.boundKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.boundKeydown);
      this.modal?.remove();
      this.preview?.remove();
    }

    onClick(event) {
      if (event.target.closest('[data-sample-open]')) return this.open();
      if (event.target.closest('[data-sample-close]')) return this.close();
      if (event.target.closest('[data-preview-close]')) return this.closePreview();
      const preview = event.target.closest('[data-preview-image]');
      if (preview?.dataset.previewImage) return this.openPreview(preview);
      const accordion = event.target.closest('[data-sample-accordion]');
      if (accordion && matchMedia('(max-width: 749px)').matches) return this.toggleCard(accordion);
      const addButton = event.target.closest('[data-sample-add]');
      if (addButton) this.addToCart(addButton);
    }

    onChange(event) {
      if (event.target.matches('[data-single-select]')) {
        const card = event.target.closest('[data-sample-card]');
        const material = card.querySelectorAll('.sample-material')[event.target.selectedIndex];
        const preview = card.querySelector('[data-single-image]');
        if (material && preview) {
          preview.dataset.previewImage = material.dataset.previewImage || '';
          preview.dataset.previewAlt = material.dataset.previewAlt || '';
          preview.querySelector('img').src = material.dataset.previewImage || '';
        }
      }
      if (event.target.matches('[data-exact-select]')) {
        const button = this.modal.querySelector('[data-select-source="exact"]');
        button.dataset.variantId = event.target.value;
      }
    }

    open() {
      this.lastFocus = document.activeElement;
      this.modal.querySelector('.sample-modal__panel').scrollTop = 0;
      this.modal.hidden = false;
      document.documentElement.classList.add('sample-modal-open');
      requestAnimationFrame(() => this.modal.classList.add('is-visible'));
      this.modal.querySelector('.sample-modal__close').focus();
    }

    close() {
      this.modal.classList.remove('is-visible');
      document.documentElement.classList.remove('sample-modal-open');
      setTimeout(() => { this.modal.hidden = true; }, 220);
      this.lastFocus?.focus();
    }

    openPreview(trigger) {
      const image = this.preview.querySelector('[data-preview-target]');
      image.src = trigger.dataset.previewImage;
      image.alt = trigger.dataset.previewAlt || '';
      this.preview.hidden = false;
      requestAnimationFrame(() => this.preview.classList.add('is-visible'));
      this.preview.querySelector('[data-preview-close]').focus();
    }

    closePreview() {
      this.preview.classList.remove('is-visible');
      setTimeout(() => { this.preview.hidden = true; }, 180);
    }

    toggleCard(button) {
      const card = button.closest('[data-sample-card]');
      const open = !card.classList.contains('is-open');
      this.modal.querySelectorAll('[data-sample-card]').forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector('[data-sample-accordion]').setAttribute('aria-expanded', 'false');
      });
      if (open) {
        card.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    }

    async addToCart(button) {
      let variantId = button.dataset.variantId;
      if (button.dataset.selectSource === 'single') variantId = button.closest('[data-sample-card]').querySelector('[data-single-select]').value;
      if (button.dataset.selectSource === 'exact') variantId = this.modal.querySelector('[data-exact-select]').value;
      if (!variantId) return this.showStatus('Please configure this sample product in the theme editor.', true);
      button.disabled = true;
      this.showStatus('Adding sample…');
      try {
        const properties = button.dataset.properties ? JSON.parse(button.dataset.properties) : {};
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties }] })
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this sample.');
        this.showStatus('Sample added to cart.');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (error) {
        this.showStatus(error.message, true);
        button.disabled = false;
      }
    }

    showStatus(message, error = false) {
      const status = this.modal.querySelector('[data-sample-status]');
      status.textContent = message;
      status.classList.toggle('is-error', error);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        if (!this.preview.hidden) this.closePreview(); else if (!this.modal.hidden) this.close();
        return;
      }
      if (event.key !== 'Tab' || this.modal.hidden) return;
      const layer = this.preview.hidden ? this.modal : this.preview;
      const focusable = [...layer.querySelectorAll('button:not([disabled]), select:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')].filter((item) => item.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
}
